var chunkMapping = {
	"636": [
		"P2C8"
	],
	"1540": [
		"bmED"
	],
	"1885": [
		"i2rS"
	],
	"5497": [
		"0Vby"
	]
};
var idToExternalAndNameMapping = {
	"P2C8": [
		"default",
		"./fonts",
		"R9v5"
	],
	"0Vby": [
		"default",
		"./ArticleV2Page",
		"sFBY"
	],
	"i2rS": [
		"default",
		"./ArticleDemo",
		"sFBY"
	],
	"bmED": [
		"default",
		"./ArticleNoImage",
		"sFBY"
	]
};
var idToRemoteMap = {
	"P2C8": [
		{
			"externalType": "script",
			"name": "hhgComponentsV2",
			"externalModuleId": "R9v5"
		}
	],
	"0Vby": [
		{
			"externalType": "script",
			"name": "hhgDiscoverV2",
			"externalModuleId": "sFBY"
		}
	],
	"i2rS": [
		{
			"externalType": "script",
			"name": "hhgDiscoverV2",
			"externalModuleId": "sFBY"
		}
	],
	"bmED": [
		{
			"externalType": "script",
			"name": "hhgDiscoverV2",
			"externalModuleId": "sFBY"
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}